// Keep API routing in one place so local UI development never silently writes
// comments/AI requests into production. CI/deployments can override this with
// REACT_APP_API_URL.
export function resolveApiBaseUrl(configuredUrl, hostname, origin) {
  if (configuredUrl) return configuredUrl.replace(/\/$/, "");
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:5447";
  }
  return `${origin}/api`;
}

export const API_BASE_URL = resolveApiBaseUrl(
  process.env.REACT_APP_API_URL,
  window.location.hostname,
  window.location.origin,
);
